import React from "react";
import {
  FaBirthdayCake,
  FaClipboardCheck,
  FaMinusCircle,
  FaUserCheck,
  FaUserTimes,
} from "react-icons/fa";

const CARDS = [
  {
    key: "present",
    label: "Présents",
    icon: FaUserCheck,
    tone:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/60",
  },
  {
    key: "absent",
    label: "Absents",
    icon: FaUserTimes,
    tone:
      "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-900/20 dark:text-rose-200 dark:ring-rose-800/60",
  },
  {
    key: "neutral",
    label: "Non saisis",
    icon: FaMinusCircle,
    tone:
      "bg-slate-50 text-slate-700 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-200 dark:ring-slate-700",
  },
  {
    key: "completion",
    label: "Appel rempli",
    suffix: "%",
    icon: FaClipboardCheck,
    tone:
      "bg-orange-50 text-orange-700 ring-orange-200 dark:bg-orange-900/20 dark:text-orange-200 dark:ring-orange-800/60",
  },
  {
    key: "birthday",
    label: "Anniversaires",
    icon: FaBirthdayCake,
    tone:
      "bg-pink-50 text-pink-700 ring-pink-200 dark:bg-pink-900/20 dark:text-pink-200 dark:ring-pink-800/60",
  },
];

export default function AttendanceKpiCards({ stats = {}, loading = false }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
      {CARDS.map((card) => {
        const Icon = card.icon;
        const value = loading ? "…" : stats?.[card.key] ?? 0;

        return (
          <div
            key={card.key}
            className={`rounded-2xl px-4 py-3 ring-1 ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {value}
                {card.suffix || ""}
              </span>
            </div>

            <p className="mt-2 text-xs font-bold uppercase tracking-wide opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}